import { Box } from '@spark-web/box';
import { Container } from '@spark-web/container';
import { Hidden } from '@spark-web/hidden';
import { Inline } from '@spark-web/inline';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';
import { TextLink } from '@spark-web/text-link';
import { ThemeProvider } from '@spark-web/theme';

const env = import.meta.env.VITE_ENVIRONMENT as string;

const defaultPrivacyLink = 'https://staging.commbank.brighte.site/privacy';
const defaultTermsLink = 'https://staging.commbank.brighte.site/website-terms';

const privateLink: Record<string, string> = {
  uat: 'https://uat.commbank.brighte.site/privacy',
  prod: 'https://commbank.brighte.com.au/privacy',
};

const termsLink: Record<string, string> = {
  uat: 'https://uat.commbank.brighte.site/website-terms',
  prod: 'https://commbank.brighte.com.au/website-terms',
};

export function Footer() {
  return (
    <ThemeProvider>
      <Box background="fieldAccent">
        <Stack as="footer" borderTop="standard">
          <Container size="medium">
            <Box paddingX={{ mobile: 'xlarge', desktop: 'large' }}>
              <Stack gap="medium" marginY="xxlarge">
                <Text>
                  Brighte is not part of the CBA Group. CommBank and its related entities do not sell, issue or
                  guarantee the obligations or performance of Brighte nor the products and services that Brighte’s
                  vendors offer. The relationship with Brighte does not represent a deposit with or liability of either
                  CommBank or any of its related bodies corporate.
                </Text>
              </Stack>
              <Stack marginY="xlarge">
                <Inline gap="small">
                  <Text>© {new Date().getFullYear()} Brighte Capital Pty Limited (ABN 74 609 165 906)</Text>
                  <Hidden below="tablet">
                    <Text>—</Text>
                  </Hidden>
                  <Text>
                    <TextLink target="_blank" href={privateLink[env] ?? defaultPrivacyLink}>
                      Privacy policy
                    </TextLink>
                  </Text>
                  <Text>—</Text>
                  <Text>
                    <TextLink target="_blank" href={termsLink[env] ?? defaultTermsLink}>
                      Website terms
                    </TextLink>
                  </Text>
                </Inline>
              </Stack>
            </Box>
          </Container>
        </Stack>
      </Box>
    </ThemeProvider>
  );
}
